export const AfterCallCanSeeOptions = [
  { value: APP.LANGUAGE.PostCallSurvey.Options[0].Id, text: APP.LANGUAGE.PostCallSurvey.Options[0].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[1].Id, text: APP.LANGUAGE.PostCallSurvey.Options[1].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[2].Id, text: APP.LANGUAGE.PostCallSurvey.Options[2].Name },
];
